import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ProfileSection from "./components/ProfileSection/ProfileSection";
import ProjectSection from "./components/ProjectSection/ProjectSection";
import DMInvitePopup from "../../components/DMInvitePopup/DMInvitePopup";
import BuilderCard from "../../components/builderCard/builderCard";
import Dashboard from "./components/Dashboard/Dashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const UserPage = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [preferences, setPreferences] = useState({});
  const [loading, setLoading] = useState(true);
  const [isDMOpen, setIsDMOpen] = useState(false);
  const [selectedUserEmail, setSelectedUserEmail] = useState(null);

  const currentUserEmail = localStorage.getItem("userEmail");

  useEffect(() => {
    const fetchUser = async () => {
      if (!username || username === "undefined") return;

      try {
        const res = await fetch(`${BACKEND_URL}/user/username/${username}`);
        const { email } = await res.json();
        if (!email) return;

        const userRes = await fetch(`${BACKEND_URL}/user/${email}`);
        const userData = await userRes.json();

        if (userRes.ok) {
          setUser(userData);
          setPreferences({
            hideContributions: userData.hideContributions ?? false,
            hideRolePrefs: userData.hideRolePrefs ?? false,
            allowMessages: userData.allowMessages ?? true,
          });
        }
      } catch (err) {
        console.error("❌ Error fetching user:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [username]);

  const isAdmin = currentUserEmail === user?.email;

  if (loading) return <p className="text-center mt-10 text-gray-500">Loading user profile...</p>;
  if (!user) return <p className="text-center mt-10 text-red-500">User not found.</p>;

  return (
    <div className="w-full">
      <div className="max-w-screen-xl mx-auto p-4 sm:p-6 md:p-8">
        <ProfileSection
          user={user}
          setUser={setUser}
          isAdmin={isAdmin}
          preferences={preferences}
          onOpenDM={(email, firstName, lastName) => {
            setSelectedUserEmail({ email, name: `${firstName} ${lastName}` });
            setIsDMOpen(true);
          }}
        />

        {/* {isAdmin && (
          <div className="mt-6 flex justify-end">
            <button
              onClick={() => navigate(`/${username}/profile/dashboard`)}
              className="px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-sky-500 text-white font-medium shadow hover:from-blue-700 hover:to-sky-600 transition"
            >
              Go to Dashboard
            </button>
          </div>
        )} */}

        {/* Builder Profile */}
        {/* {user?.builderProfile && (
          <section className="mt-10">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-gray-900">Builder Profile</h3>
            </div>

            <div className="mt-3">
              <BuilderCard
                profile={user.builderProfile}
                identity={
                  Array.isArray(user.builderProfile.identity)
                    ? user.builderProfile.identity
                    : [user.builderProfile.identity1, user.builderProfile.identity2].filter(Boolean)
                }
                profileImage={user.profileImage}
              />
            </div>
          </section>
        )} */}

        <div className="mt-12">
          <ProjectSection
            user={user}
            userEmail={user.email}
            isAdmin={isAdmin}
            username={username}
            preferences={preferences}
          />
        </div>
      </div>

      {isDMOpen && selectedUserEmail && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
          <DMInvitePopup
            applicantEmail={selectedUserEmail.email}
            applicantName={selectedUserEmail.name}
            onClose={() => setIsDMOpen(false)}
            navigate={(chatId) =>
              window.location.assign(
                `/messages/${[localStorage.getItem("userEmail"), selectedUserEmail.email]
                  .sort()
                  .join("_")}`
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default UserPage;
